import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=3cac45fb&scoped=true&"
import script from "./SectionTitle.vue?vue&type=script&lang=js&"
export * from "./SectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=3cac45fb&scoped=true&lang=css&"
import style1 from "./SectionTitle.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac45fb",
  null
  
)

export default component.exports